import { useLanguageContext } from "../../../context/LanguageContext";
import useLocationEditRouteConfig from "../../../routes/configs/companies/locations/LocationEditRouteConfig";
import useLocationCreateRouteConfig from "../../../routes/configs/companies/locations/LocationCreateRouteConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import DataTable, { useDataTable } from "../main/DataTable";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";

function LocationsDataTable({ companyId }) {
  const { translate } = useLanguageContext();

  //Create the datatable config
  const config = new DataTableConfig("locations");

  //Set the datatable header
  config.setHeader(translate("eva.main.entities.locations"));

  //Set the datatable fetch info
  config.setFetchRequest(`locations/${companyId}`);

  //Set the datatable order by
  config.setOrderBy("name");
  config.setOrderDirection("asc");

  //set the datatable columns
  config.setColumns([
    useBasicColumnConfig("name").setLockActive(true),
    useBasicColumnConfig("address"),
    useBasicColumnConfig("timezone")
      .setData(
        (row) => row.timezone ?? translate("eva.main.company.timezone.inherit")
      )
      .setActive(false),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("location", useLocationEditRouteConfig()),
    useDeleteRowActionConfig(
      "location",
      (row) => `locations/${companyId}/${row.id}`,
      true
    ).setDisabled((row, dataTable) => dataTable.data?.records?.length === 1),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig("location", useLocationCreateRouteConfig()),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default LocationsDataTable;
